import {shopUtilities} from '@global/shop-utilities/shop-utilities';
import {consentPromise} from '@utilities/sal-usercentrics/sal-usercentrics';

const tracking_events = {
    AddToCart: '0',                 // payload = { id }
    AddToWishlist: '1',             // payload = { id }
    ClickEmail: '10',               // payload = email
    ClickPhone: '11',               // payload = number
    ClickHttp: '100',               // payload = url (external links only)
    ClickDownload: '101',           // payload = { dlcat: category, dlid: identifier }
    ClickSocial: '110',             // payload = Link text
    ClickFlyout: '111',             // payload = null
    ClickNewsletter: '112',         // payload = null
    SubscribeNewsletter: '113',     // payload = { variant: string, categories: CSV}
    ClickLogin: '200',              // payload = null
    ClickRegister: '210',           // payload = null
    AddToDealerRequest: '1000',     // payload = null
    UrlContainsMoodboard: '2000',   // payload = null
    UrlContainsWorkapp: '2010',     // payload = null
    UrlContainsWoodpro: '2020',     // payload = null
    MoodboardUpload: '3001',        // payload = null
    RoomDesignerOpen: '3002',       // payload = CSV of selected decor numbers
    ConstructionStageSlideInteraction: '4001', // payload = null
    ConstructionStageCategoryInteraction: '4002',// payload = null
    ConstructionStageLayerInteraction: '4003', // payload = Bauteil-Name
    ConstructionStageSelectCategory: '4004', // payload = Kategorie-Name
    ConstructionStageSelectBauteil: '4005', // payload = Bauteil-Name
    ConstructionStageClickProduct: '4006', // payload = Produkt-Name
    SearchPage: '5001', // payload = searchterm
    SearchQuicksearch: '5002', // payload = searchterm
    SearchAvailabilityEntrypage: '5003', // payload = searchterm
    global_gallery_slider_navigate_auto: '5648', // payload = { category: string, title: string }
    global_gallery_slider_navigate: '5649', // payload = { category: string, title: string }
    global_gallery_slider_click: '5650', // payload = { category: string, title: string }
    kundenportal_product_combo_stockcheck: '5700', // payload = { dekor, struktur, produkt, matnr, query, result }
};

const hrefTracking = aTag => {
    // Klick auf Externe Links
    if (/^http/.test(aTag.href) && !aTag.href.includes(document.location.origin)) {
        track_abstract.trigger_event(tracking_events.ClickHttp, aTag.href.replace(document.location.origin, ''));
    }

    // Klick auf Mailto:Links
    if (/^javascript:linkTo_UnCryptMailto/.test(aTag.href)) {
        track_abstract.trigger_event(tracking_events.ClickEmail, aTag.textContent);
    }

    // Klick auf Tel:Links
    if (/^tel:/.test(aTag.href)) {
        track_abstract.trigger_event(tracking_events.ClickPhone, aTag.textContent);
    }

    // Klick auf Link zu Newsletter
    if (/SSO\/Newsletter_subscribe/i.test(aTag.href)) {
        track_abstract.trigger_event(tracking_events.ClickNewsletter, null);
    }
    if (/newsletter.pfleiderer.com/i.test(aTag.href)) {
        track_abstract.trigger_event(tracking_events.ClickNewsletter, null);
    }

    // Klick auf Logins
    if (/SSO\/Login\?client_id=salientshop/i.test(aTag.href) && /auth.pfleiderer.com/i.test(aTag.href)) {
        track_abstract.trigger_event(tracking_events.ClickLogin, null);
    }

    // Klick auf Registrierung
    if (/auth.pfleiderer.com/i.test(aTag.href)) {
        if (/\/Registrierung/i.test(aTag.href)
            || /\/register/i.test(aTag.href)
            || /\/sinscrire/i.test(aTag.href)
            || /\/registro/i.test(aTag.href)
            || /\/Registrace/i.test(aTag.href)
            || /\/Registrera_dig/i.test(aTag.href)
            || /\/註冊/i.test(aTag.href)
        ) {
            track_abstract.trigger_event(tracking_events.ClickRegister, null);
        }
    }
}

const downloadTracking = aTag => {
    // Klick auf Downloads
    track_abstract.trigger_event(tracking_events.ClickDownload, aTag.dataset);
}

const classTracking = aTag => {
    // Klick auf Social Media Links
    if (aTag.classList.contains("social__link")) {
        track_abstract.trigger_event(tracking_events.ClickSocial, aTag.textContent.trim());
    }

    // Klick auf Kontakt-Flyout
    if (aTag.classList.contains("button-contact")) {
        track_abstract.trigger_event(tracking_events.ClickFlyout, null);
    }
}

const isTrackableClick = (e) => {
    if (!e.target) {
        return
    }

    // A-Tag raussuchen
    const aTag = e.target.closest('a');

    if (aTag === null) {
        return;
    }

    // HREF Tracking
    if (aTag.href) {
        hrefTracking(aTag)
    }

    // Dataset tracking
    if (aTag.dataset.dlcat) {
        downloadTracking(aTag)
    }

    // Class tracking
    if (aTag.classList) {
        classTracking(aTag)
    }
}

const trackableEvents = () => {
    // Klick auf Add To Wishlist
    shopUtilities.added((e) => {
        track_abstract.trigger_event(tracking_events.AddToWishlist, e.detail);
    }, false, 'wishlist');

    // Klick auf Add To Warenkorb
    shopUtilities.added((e) => {
        track_abstract.trigger_event(tracking_events.AddToCart, e.detail);
    }, false, 'cart');

    // Klick auf Ask a Distributor
    shopUtilities.added(() => {
        track_abstract.trigger_event(tracking_events.AddToDealerRequest, null);
    }, false, 'productCombo');
}

const trackableUrls = () => {
    if (/moodboard/i.test(document.location.href)) {
        track_abstract.trigger_event(tracking_events.UrlContainsMoodboard, null);
    }

    if (/woodpro/i.test(document.location.href)) {
        track_abstract.trigger_event(tracking_events.UrlContainsWoodpro, null);
    }

    if (/workapp/i.test(document.location.href)) {
        track_abstract.trigger_event(tracking_events.UrlContainsWorkapp, null);
    }
}

const guardedStartTracking = (consentId, tracker) => {
    if (typeof tracker.start_tracking === 'function') {
        consentPromise(consentId).then(() => {
            tracker.start_tracking();
        });
    }
}

// If a tracker is registered after start_tracking was called, call tracker.start_tracking immediately
let tracking_started = false;
const eventTracker = new Map();
const track_abstract = {
    use: (consentId, tracker, startImmediately = false) => {
        eventTracker.set(consentId, tracker);
        if ((startImmediately || tracking_started)) {
            guardedStartTracking(consentId, tracker)
        }
    },
    start_tracking: () => {
        tracking_started = true;
        eventTracker.forEach((tracker, consentId) => {
            guardedStartTracking(consentId, tracker)
        });
    },
    trigger_event: (event, payload) => {
        if (/pfl-typo3.ddev.site/.test(window.location.href)) {
            console.warn(Object.keys(tracking_events).find(key => tracking_events[key] === event) + ' triggered', payload)
        }
        eventTracker.forEach(tracker => {
            if (typeof tracker.track_event === 'function') {
                tracker.track_event(event, payload);
            }
        });
    }
};


// Always INIT ;-)
track_abstract.start_tracking();
document.addEventListener('click', isTrackableClick)
trackableEvents();
trackableUrls();

export {track_abstract, tracking_events};
